import { RolesData } from '../../types/roles';
import {
  FETCH_ROLES_SUCCESS,
  FetchRolesSuccessAction,
  SET_ROLE_SUCCESS,
  SetRoleSuccessAction,
  REMOVE_ROLE_SUCCESS,
  RemoveRoleSuccessAction,
} from '../actions/action-types';

export const roles = (state: RolesData = [], action: FetchRolesSuccessAction | SetRoleSuccessAction | RemoveRoleSuccessAction): RolesData => {
  switch (action.type) {
    case FETCH_ROLES_SUCCESS:
      return action.roles;
    case SET_ROLE_SUCCESS:
      const roleIndex = getRoleIndex(state, action.role.id);
      return [...state.slice(0, roleIndex), action.role, ...state.slice(roleIndex + 1)];
    case REMOVE_ROLE_SUCCESS:
      return state.filter(role => action.roleId !== role.id);
    default:
      return state;
  }
};

const getRoleIndex = (rolesData: RolesData, roleId: string): number => {
  const roleIndex = rolesData.findIndex(role => roleId === role.id);
  return roleIndex > -1 ? roleIndex : rolesData.length;
};
